import { Box, Flex, Heading } from '@chakra-ui/react';
import { useMutation, useQuery } from 'react-query';
import React from 'react';
import { getPost } from '../../../service';
import FormHeader from '../../../Widget/FormHeader';

type Props = {
  formId: string;
};
function ParticipationContentItemApply({ formId  }: Props) {

  const { isLoading, error, data } = useQuery('getPage', () => getPost(formId));

  return (
    <>
    <Heading size="4xl" color="b.dgr" pt="9" pb="9">모집공고 | 행사안내</Heading>
    <FormHeader
      title={data?.title}
      content={data?.content}
      featured_full={data?.featured_full}
      displayButton={true}
      url={data?.meta?.form_external_link !== '' ? data?.meta?.form_external_link : `/form/?form_id=${formId}`}
      target={data?.meta?.form_external_link !== '' ? data?.meta?.form_target : ''}
    />
    </>
  );
}

ParticipationContentItemApply.defaultProps = {
};

export default ParticipationContentItemApply;
